export interface StableRpcErrorData {
  retryable?: boolean
  status?: number
  businessCode?: string | number
}

function getOwnDataProperty(value: object, key: keyof StableRpcErrorData): unknown {
  return Object.getOwnPropertyDescriptor(value, key)?.value
}

export function extractStableRpcErrorData(value: unknown): StableRpcErrorData | undefined {
  if ((typeof value !== 'object' && typeof value !== 'function') || value === null) return undefined

  const data: StableRpcErrorData = {}
  const retryable = getOwnDataProperty(value, 'retryable')
  const status = getOwnDataProperty(value, 'status')
  const businessCode = getOwnDataProperty(value, 'businessCode')

  if (typeof retryable === 'boolean') data.retryable = retryable
  if (typeof status === 'number' && Number.isSafeInteger(status)) data.status = status
  if (
    typeof businessCode === 'string'
    || (typeof businessCode === 'number' && Number.isFinite(businessCode))
  ) {
    data.businessCode = businessCode
  }

  return Object.keys(data).length > 0 ? data : undefined
}

export function restoreStableRpcErrorData(error: Error, data: unknown): void {
  const stableData = extractStableRpcErrorData(data)
  if (stableData) Object.assign(error, stableData)
}
